let jwtEnabled: undefined | boolean = undefined;

function get() {
  return window.localStorage.getItem(`$$LOGIN_STRATEGY$$`);
}

function set(value: string | number | boolean) {
  return window.localStorage.setItem(`$$LOGIN_STRATEGY$$`, `${value}`);
}

/* istanbul ignore next */
function isShopifyEmbedded() {
  const searchParams = new URLSearchParams(window.location.search);
  try {
    const asUrl1 = new URL(`${searchParams.get('referrer')}`);
    const asUrl2 = new URL(`${process.env.SHOPIFY_EMBEDDED_HOST}`);
    return asUrl1.origin === asUrl2.origin;
  } catch (e) {
    return false;
  }
}

export const setJWT = () => {
  // We cannot use localStorage for the shopify embedded
  // app bc it does not work when cookies/storage are blocked
  if (isShopifyEmbedded()) {
    return Promise.resolve(false);
  }

  if (process.env.LOGIN_STRATEGY === 'jwt') {
    jwtEnabled = true;
    set(`jwt`);
    return Promise.resolve(true);
  }

  // Its already set
  if (get() === 'jwt') {
    jwtEnabled = true;
  } else {
    jwtEnabled = false;
  }

  return Promise.resolve(jwtEnabled);
};
